import React from "react";
import Header from "./header";
import { PRACTICE_EDITION_WHITELABEL } from "../../constants/constants";

const MobileHeader = (props) => {
  return (
    (!PRACTICE_EDITION_WHITELABEL || process.env?.NODE_ENV === "test") && (
      <Header backgroundColor="black-bg" {...props} />
    )
  );
};

export default MobileHeader;
